import { Dialog as DialogPrimitive } from '@base-ui/react/dialog';

export type DialogProps = DialogPrimitive.Root.Props;

const Dialog = ({ ...props }: DialogProps) => {
  return <DialogPrimitive.Root data-slot="dialog" {...props} />;
};

export default Dialog;
